import { Layer } from '@deck.gl/core';
import ParticleLayer from './layers/particles/ParticleLayer';
import { MS_TO_KT } from '@fe/core';
import { DeckLayerCreator } from './deck-layer-creator';

export class DeckParticles extends DeckLayerCreator {
    createLayers(): Layer[] {
        const { windParticles: props } = this.props || {};
        if (!this.overlay || !props?.isEnabled) {
            return [];
        }

        const { currentColor, opacity } = props;
        const zoom = this.plugin.map?.getZoom() ?? 0;
        const numParticles = Math.ceil(8000 / (Math.floor(zoom) > 0 ? 0.8 * Math.floor(zoom) : 1));
        return [
            new ParticleLayer({
                id: 'wind-particles',
                image: props.data,
                imageUnscale: [-128 * MS_TO_KT, 127 * MS_TO_KT],
                bounds: [-180, -90, 180, 90],
                numParticles,
                maxAge: 34,
                speedFactor: 4.2,
                color: currentColor,
                width: 2,
                opacity,
                fps: 22,
                updateTriggers: {
                    numParticles: [numParticles],
                    color: [currentColor]
                },
                parameters: this.plugin.getRenderingParams({
                    cullMode: 'front'
                })
            } as any)
        ];
    }
}
